<button pButton class="p-button-raised p-button-text cbms-row-button" (click)="showDataPointPropertiesDialog()"
        pTooltip="Read properties" showDelay="1000" hideDelay="500">
    <mat-icon svgIcon="description"></mat-icon>
</button>
